export default __webpack_public_path__ + "static/media/viewmore.474006d1.svg";